import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { ReactNode } from "react";

const { confirm } = Modal;

type ConfirmOptions = {
  title: string;
  content?: string;
  okText?: string;
  cancelText?: string;
  okType?: "primary" | "danger" | "default";
  loading?: boolean;
  onOk: () => Promise<void> | void;
  onCancel?: () => void;
  icon?: ReactNode;
};

export const showConfirmDialog = ({
  title,
  content,
  okText = "OK",
  cancelText = "Cancel",
  okType = "primary",
  loading = false,
  onOk,
  onCancel,
  icon,
}: ConfirmOptions) => {
  confirm({
    title,
    icon: icon ?? <ExclamationCircleOutlined />,
    content,
    okText,
    cancelText,
    okType,
    okButtonProps: { disabled: loading },
    onOk,
    onCancel,
  });
};
